angular.module('app.controllers').controller('PrintPhasesCtrl', function ($httpParamSerializerJQLike, usersOptions, groupsOptions) {
    const vm = this;

    vm.for_who = '';
    vm.print = {
        date: moment().format('YYYY-MM-DD'),
    };
    vm.types = ['measurement', 'installation', 'transport', 'service'];

    vm.groupsOptions = groupsOptions;
    vm.usersOptions = usersOptions;

    vm.getUrl = () => `/print/phases/day?${$httpParamSerializerJQLike(vm.print)}`;
});
